import { createFileRoute, Outlet } from '@tanstack/react-router';

const OperatorsServicesLayoutPage = () => {
  return <Outlet />;
};

export const Route = createFileRoute('/_protected/operators/services')({
  component: OperatorsServicesLayoutPage,
});
